import React, { useContext } from 'react';
import Card from '@mui/material/Card';

import BasicLayout from '../_components/BasicLayout';
import { LoadingButton } from '@mui/lab';
import { Box, CardActionArea, Typography } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { RegisterFormSchema } from 'services/AuthService/schemas';
import SvgUndraw from 'assets/images/svgs/SignInSVGS/6.svg';
import { useAuthenticationContext } from '../context/AuthenticationContextProvider';
import { doRegisterAsync } from 'services/AuthService';
import { AppContext } from 'context/AppContextProvider';
import zod from 'zod';

type SignUpFormData = zod.infer<typeof RegisterFormSchema>;

const ConfirmationDataPage = () => {
  const {
    handleSubmit,
    formState: { errors },
    getValues,
  } = useAuthenticationContext();

  const navigate = useNavigate();
  const formData = getValues();

  const { showSnackbar } = useContext(AppContext);

  const handleRegister = async (data: SignUpFormData) => {
    try {
      await doRegisterAsync(data);
      navigate('/app/authentication/signIn');
      showSnackbar('Sucesso!', 'success');
    } catch (error) {
      return error;
    }
  };

  return (
    <BasicLayout>
      <Card
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-start',
          width: '80%',
          height: '100%',
          backgroundColor: 'transparent',
        }}
      >
        {window.innerWidth > 1500 && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'flex-start',
              width: '100%',
              height: '100%',
              backgroundColor: 'transparent',
            }}
          >
            <Box
              display={'flex'}
              alignContent={'center'}
              justifyContent={'center'}
              marginY={5}
            >
              <img src={SvgUndraw} height={450} />
            </Box>
            <Box>
              <Typography fontSize={'20px'} marginY={0}>
                Olá {formData.name}!
              </Typography>
              <Typography fontSize={'25px'} marginY={2}>
                Seja bem vindo,
                <br /> confirme seu cadatro.
              </Typography>
            </Box>
          </Box>
        )}
        <CardActionArea
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'white',
            width: '100%',
            height: { md: '50%', xs: '80%' },
            margin: '10px',
            border: '5px solid',
            borderImage:
              'linear-gradient(45deg, white 5%, rgb(6, 152, 243) 50%) 5',
            backgroundSize: '120% 120%',
            transition: 'transform 0.3s, box-shadow 0.3s',
            position: 'relative',
            animation: 'rotateBorder 5s linear infinite',
            '&:before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              borderRadius: '10px',
              zIndex: -1,
            },
            '&:hover': {
              transform: 'scale(1.05)',
            },
          }}
        >
          <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            justifyContent="center"
            padding={3}
            sx={{
              width: '100%',
              height: '100%',
              overflowY: 'auto',
              color: 'rgb(71, 71, 71)',
            }}
          >
            <Typography
              sx={{
                fontWeight: 'bold',
                justifyContent: 'center',
                textAlign: 'center',
                width: '100%',
                marginBottom: '40px',
              }}
              variant="h4"
              gutterBottom
            >
              Dados do Cadastro
            </Typography>
            <Typography variant="h6" gutterBottom>
              <strong>Nome:</strong> {formData.name}
            </Typography>
            <Typography variant="h6" gutterBottom>
              <strong>Email:</strong> {formData.email}
            </Typography>
            <Typography variant="h6" gutterBottom>
              <strong>Endereço:</strong> {formData.addrNumber}
            </Typography>
            <Typography variant="h6" gutterBottom>
              <strong>Cidade:</strong> {formData.city}
            </Typography>
            <Typography variant="h6" gutterBottom>
              <strong>Estado:</strong> {formData.state}
            </Typography>
            <Typography variant="h6" gutterBottom>
              <strong>CEP:</strong> {formData.postalCode}
            </Typography>
            <Typography variant="h6" gutterBottom>
              <strong>Plano Contratado:</strong> {formData.plans}
            </Typography>
          </Box>
          <Box
            display={'flex'}
            justifyContent={'space-between'}
            alignItems={'center'}
            width={'90%'}
            height={'10%'}
          >
            <LoadingButton
              color="primary"
              variant="outlined"
              loadingPosition="end"
              sx={{
                width: '100px',
                height: '35px',
                margin: '2px',
              }}
              component={Link}
              to="/app/authentication/signUpProduct"
            >
              Voltar
            </LoadingButton>
            <LoadingButton
              color="primary"
              variant="contained"
              loadingPosition="center"
              sx={{
                width: '110px',
                height: '35px',
              }}
              onClick={handleSubmit(handleRegister)}
            >
              Confirmar
            </LoadingButton>
          </Box>
        </CardActionArea>
      </Card>
    </BasicLayout>
  );
};

export default ConfirmationDataPage;
